export default "__VITE_ASSET__llcDi7fG__"